import { FC, useEffect, useRef } from 'react';
import { Box } from '@zoopla-eng/zds-components/box';

import { StyledTitle } from './Confirmation.styles';

type ConfirmationProps = {
    title: string;
};

export const Confirmation: FC<React.PropsWithChildren<ConfirmationProps>> = ({
    title,
    children
}) => {
    const titleRef = useRef<HTMLHeadingElement>(null);

    useEffect(() => {
        titleRef?.current?.focus();
    }, []);

    return (
        <>
            <Box pb="$S500" bpM100={{ pb: '$M200' }}>
                <StyledTitle ref={titleRef} tabIndex={-1}>
                    {title}
                </StyledTitle>
            </Box>
            {children}
        </>
    );
};
